export const PRODUCT_FILTERS = {
  genders: ["Women", "Men", "Unisex"],
  categories: [
    "T-Shirts & Tops",
    "Sweaters & Knitwear",
    "Pants & Shorts",
    "Underwear & Lingerie",
    "Activewear & Workout",
  ],
  seasons: ["Spring", "Summer", "Autumn", "Winter"],
  materials: [
    "Organic Bamboo Silk",
    "Raw Hemp Jersey",
    "Bamboo-Hemp Blend",
    "Bamboo Lace & Satin",
    "Bamboo Compression Knit",
  ],
  sizes: ["XS", "S", "M", "L", "XL", "XXL"],
  palettes: ["Obsidian Black", "Raw Ecru", "Sage Moss", "Terracotta Rose", "Deep Indigo"],
};

export const CHAKRAS = [
  {
    id: "crown",
    number: 7,
    sanskrit: "Sahasrara",
    name: "Crown Chakra",
    element: "Pure Consciousness",
    color: "#A855F7",
    petals: 1000,
    yPercent: 12,
  },
  {
    id: "thirdeye",
    number: 6,
    sanskrit: "Ajna",
    name: "Third Eye Chakra",
    element: "Light & Intuition",
    color: "#6366F1",
    petals: 96,
    yPercent: 22,
  },
  {
    id: "throat",
    number: 5,
    sanskrit: "Vishuddha",
    name: "Throat Chakra",
    element: "Ether & Resonance",
    color: "#06B6D4",
    petals: 16,
    yPercent: 34,
  },
  {
    id: "heart",
    number: 4,
    sanskrit: "Anahata",
    name: "Heart Chakra",
    element: "Air & Harmony",
    color: "#10B981",
    petals: 12,
    yPercent: 46,
  },
  {
    id: "solar",
    number: 3,
    sanskrit: "Manipura",
    name: "Solar Plexus Chakra",
    element: "Fire & Vitality",
    color: "#EAB308",
    petals: 10,
    yPercent: 58,
  },
  {
    id: "sacral",
    number: 2,
    sanskrit: "Svadhisthana",
    name: "Sacral Chakra",
    element: "Water & Creation",
    color: "#F97316",
    petals: 6,
    yPercent: 70,
  },
  {
    id: "root",
    number: 1,
    sanskrit: "Muladhara",
    name: "Root Chakra",
    element: "Earth & Grounding",
    color: "#EF4444",
    petals: 4,
    yPercent: 82,
  },
];

export const INK_COLORS = [
  { name: "Telluric Crimson", hex: "#EF4444", chakraId: "root" },
  { name: "Sacral Amber", hex: "#F97316", chakraId: "sacral" },
  { name: "Solar Gold", hex: "#EAB308", chakraId: "solar" },
  { name: "Gaia Emerald", hex: "#10B981", chakraId: "heart" },
  { name: "Ether Cyan", hex: "#06B6D4", chakraId: "throat" },
  { name: "Indigo Aura", hex: "#6366F1", chakraId: "thirdeye" },
  { name: "Crown Violet", hex: "#A855F7", chakraId: "crown" },
  { name: "Pure Ivory", hex: "#F8FAFC", chakraId: "crown" },
];

export const INITIAL_PRODUCTS = [
  // ===================== WOMEN'S BASICS (T-SHIRTS, SWEATERS, PANTS, SHORTS) =====================
  {
    id: "womens-bamboo-draped-tee",
    name: "Women's Essential Bamboo Crew Tee",
    price: 58.0,
    gender: "Women",
    category: "T-Shirts & Tops",
    subcategory: "T-Shirts",
    season: "Spring",
    material: "Organic Bamboo Silk",
    sizes: ["XS", "S", "M", "L", "XL"],
    color_palette: "Raw Ecru",
    eco_rating: 98.5,
    carbon_label: "98.5% Carbon Negative",
    stock: 48,
    is_new: true,
    featured: true,
    activation_temp: "None",
    description:
      "Ultra-soft, unbranded generic bamboo jersey crewneck tee for women. Tailored with a flattering drape, breathable weave, and zero external logos for effortless everyday elegance.",
    images: [
      "https://images.unsplash.com/photo-1521572267360-ee0c2909d518?auto=format&fit=crop&w=900&q=85",
      "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Organic Bamboo Viscose", percent: 95 },
      { material: "Plant Elastane", percent: 5 },
    ],
    tech_pack: {
      chest: "94 cm",
      sleeve: "19 cm",
      length: "62 cm",
      fiber_density: "180 GSM",
      tensile_strength: "32 N/mm²",
      weight_gsm: "180",
    },
    created_at: "2026-06-20T12:00:00.000Z",
  },
  {
    id: "womens-hemp-ribbed-sweater",
    name: "Women's Hemp & Bamboo Knit Sweater",
    price: 128.0,
    gender: "Women",
    category: "Sweaters & Knitwear",
    subcategory: "Sweaters",
    season: "Autumn",
    material: "Bamboo-Hemp Blend",
    sizes: ["XS", "S", "M", "L", "XL"],
    color_palette: "Sage Moss",
    eco_rating: 97.9,
    carbon_label: "97.9% Carbon Negative",
    stock: 34,
    is_new: true,
    featured: true,
    activation_temp: "None",
    description:
      "Relaxed Fisherman-rib sweater spun from organic hemp and brushed bamboo yarn. Warm yet breathable for autumn and winter layering.",
    images: [
      "https://images.unsplash.com/photo-1576566588028-4147f3842f27?auto=format&fit=crop&w=900&q=85",
      "https://images.unsplash.com/photo-1434389677669-e08b4cac3105?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Raw Hemp Fiber", percent: 55 },
      { material: "Organic Bamboo Yarn", percent: 45 },
    ],
    tech_pack: {
      chest: "108 cm",
      sleeve: "61 cm",
      length: "64 cm",
      fiber_density: "360 GSM",
      tensile_strength: "48 N/mm²",
      weight_gsm: "360",
    },
    created_at: "2026-06-19T12:00:00.000Z",
  },
  {
    id: "womens-bamboo-wide-leg-pants",
    name: "Women's Bamboo Wide-Leg Lounge Pants",
    price: 110.0,
    gender: "Women",
    category: "Pants & Shorts",
    subcategory: "Pants",
    season: "Winter",
    material: "Bamboo-Hemp Blend",
    sizes: ["XS", "S", "M", "L", "XL"],
    color_palette: "Obsidian Black",
    eco_rating: 98.1,
    carbon_label: "98.1% Carbon Negative",
    stock: 40,
    is_new: false,
    featured: false,
    activation_temp: "None",
    description:
      "High-rise, floor-grazing wide-leg trousers in heavyweight bamboo-hemp french terry. Minimalist waist with deep side seam pockets.",
    images: [
      "https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?auto=format&fit=crop&w=900&q=85",
      "https://images.unsplash.com/photo-1509631179647-0177331693ae?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Bamboo French Terry", percent: 70 },
      { material: "Organic Hemp", percent: 30 },
    ],
    tech_pack: {
      chest: "—",
      sleeve: "—",
      length: "106 cm",
      fiber_density: "310 GSM",
      tensile_strength: "45 N/mm²",
      weight_gsm: "310",
    },
    created_at: "2026-06-18T12:00:00.000Z",
  },
  {
    id: "womens-hemp-summer-shorts",
    name: "Women's Hemp Breeze Everyday Shorts",
    price: 68.0,
    gender: "Women",
    category: "Pants & Shorts",
    subcategory: "Shorts",
    season: "Summer",
    material: "Raw Hemp Jersey",
    sizes: ["XS", "S", "M", "L", "XL"],
    color_palette: "Raw Ecru",
    eco_rating: 98.8,
    carbon_label: "98.8% Carbon Negative",
    stock: 52,
    is_new: true,
    featured: false,
    activation_temp: "None",
    description:
      "Crisp, high-waisted summer shorts woven from raw organic hemp and bamboo lining. Naturally UV-protective and moisture-wicking.",
    images: [
      "https://images.unsplash.com/photo-1591195853828-11db59a44f6b?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Raw Hemp", percent: 80 },
      { material: "Bamboo Viscose", percent: 20 },
    ],
    tech_pack: {
      chest: "—",
      sleeve: "—",
      length: "38 cm",
      fiber_density: "220 GSM",
      tensile_strength: "50 N/mm²",
      weight_gsm: "220",
    },
    created_at: "2026-06-17T12:00:00.000Z",
  },

  // ===================== WOMEN'S UNDERWEAR & SEXY LINGERIE =====================
  {
    id: "womens-bamboo-lace-plunge-bodysuit",
    name: "Gaia Sheer Bamboo Lace Plunge Bodysuit",
    price: 96.0,
    gender: "Women",
    category: "Underwear & Lingerie",
    subcategory: "Sexy Lingerie",
    season: "Summer",
    material: "Bamboo Lace & Satin",
    sizes: ["XS", "S", "M", "L", "XL"],
    color_palette: "Obsidian Black",
    eco_rating: 97.6,
    carbon_label: "97.6% Carbon Negative",
    stock: 28,
    is_new: true,
    featured: true,
    activation_temp: "None",
    description:
      "Sensual, figure-sculpting bodysuit crafted from sheer botanical bamboo lace and liquid bamboo satin. Features a daring deep-V plunge neckline, high-cut Brazilian leg, and open back.",
    images: [
      "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&w=900&q=85",
      "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Botanical Bamboo Lace", percent: 68 },
      { material: "Bamboo Silk Satin", percent: 24 },
      { material: "Bio-Elastane", percent: 8 },
    ],
    tech_pack: {
      chest: "86 cm",
      sleeve: "—",
      length: "70 cm",
      fiber_density: "135 GSM",
      tensile_strength: "26 N/mm²",
      weight_gsm: "135",
    },
    created_at: "2026-06-16T12:00:00.000Z",
  },
  {
    id: "womens-strappy-silk-bamboo-teddy-garter",
    name: "Telluric Strappy Silk-Bamboo Lingerie Set",
    price: 118.0,
    gender: "Women",
    category: "Underwear & Lingerie",
    subcategory: "Sexy Lingerie",
    season: "Spring",
    material: "Bamboo Lace & Satin",
    sizes: ["XS", "S", "M", "L"],
    color_palette: "Terracotta Rose",
    eco_rating: 97.4,
    carbon_label: "97.4% Carbon Negative",
    stock: 22,
    is_new: true,
    featured: true,
    activation_temp: "None",
    description:
      "Three-piece luxury boudoir lingerie set featuring an underwire demi balconette bra, adjustable strappy waist garter belt, and matching V-string thong in silk-soft bamboo mesh.",
    images: [
      "https://images.unsplash.com/photo-1502716119720-b23a93e5fe1b?auto=format&fit=crop&w=900&q=85",
      "https://images.unsplash.com/photo-1469334031218-e382a71b716b?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Bamboo Silk Mesh", percent: 75 },
      { material: "Organic Lace Trim", percent: 20 },
      { material: "Bio-Elastane", percent: 5 },
    ],
    tech_pack: {
      chest: "84 cm",
      sleeve: "—",
      length: "—",
      fiber_density: "120 GSM",
      tensile_strength: "24 N/mm²",
      weight_gsm: "120",
    },
    created_at: "2026-06-15T12:00:00.000Z",
  },
  {
    id: "womens-satin-cowl-chemise",
    name: "Solstice Open-Back Bamboo Satin Slip Lingerie",
    price: 88.0,
    gender: "Women",
    category: "Underwear & Lingerie",
    subcategory: "Sexy Lingerie",
    season: "Summer",
    material: "Bamboo Lace & Satin",
    sizes: ["XS", "S", "M", "L", "XL"],
    color_palette: "Obsidian Black",
    eco_rating: 98.0,
    carbon_label: "98.0% Carbon Negative",
    stock: 30,
    is_new: true,
    featured: false,
    activation_temp: "None",
    description:
      "Bias-cut mini chemise slip in luminous 100% bamboo charmeuse satin. Designed with a draped cowl neckline, delicate roulette straps, and a dramatic low crisscross back.",
    images: [
      "https://images.unsplash.com/photo-1539109136881-3be0616acf4b?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Bamboo Charmeuse Satin", percent: 100 },
    ],
    tech_pack: {
      chest: "88 cm",
      sleeve: "—",
      length: "78 cm",
      fiber_density: "140 GSM",
      tensile_strength: "28 N/mm²",
      weight_gsm: "140",
    },
    created_at: "2026-06-14T12:00:00.000Z",
  },
  {
    id: "womens-bamboo-bralette-brief-set",
    name: "Women's Second-Skin Bamboo Bra & Underwear Set",
    price: 64.0,
    gender: "Women",
    category: "Underwear & Lingerie",
    subcategory: "Underwear & Bras",
    season: "Spring",
    material: "Organic Bamboo Silk",
    sizes: ["XS", "S", "M", "L", "XL"],
    color_palette: "Raw Ecru",
    eco_rating: 99.1,
    carbon_label: "99.1% Carbon Negative",
    stock: 65,
    is_new: false,
    featured: false,
    activation_temp: "None",
    description:
      "Everyday wireless triangle bralette and high-leg bikini brief crafted from hypoallergenic, breathable organic bamboo micro-rib.",
    images: [
      "https://images.unsplash.com/photo-1516762689617-e1cffcef479d?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Organic Bamboo Micro-Rib", percent: 92 },
      { material: "Plant Elastane", percent: 8 },
    ],
    tech_pack: {
      chest: "86 cm",
      sleeve: "—",
      length: "—",
      fiber_density: "165 GSM",
      tensile_strength: "30 N/mm²",
      weight_gsm: "165",
    },
    created_at: "2026-06-13T12:00:00.000Z",
  },

  // ===================== MEN'S BASICS & UNDERWEAR =====================
  {
    id: "mens-hemp-bamboo-crew-tee",
    name: "Men's Heavyweight Hemp & Bamboo Tee",
    price: 62.0,
    gender: "Men",
    category: "T-Shirts & Tops",
    subcategory: "T-Shirts",
    season: "Summer",
    material: "Bamboo-Hemp Blend",
    sizes: ["S", "M", "L", "XL", "XXL"],
    color_palette: "Obsidian Black",
    eco_rating: 98.4,
    carbon_label: "98.4% Carbon Negative",
    stock: 70,
    is_new: true,
    featured: true,
    activation_temp: "None",
    description:
      "Clean, unbranded architectural crewneck T-shirt for men. Structured hemp exterior with a cooling bamboo interior face that softens with every wash.",
    images: [
      "https://images.unsplash.com/photo-1521572267360-ee0c2909d518?auto=format&fit=crop&w=900&q=85",
      "https://images.unsplash.com/photo-1618354691373-d851c5c3a990?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Organic Bamboo", percent: 60 },
      { material: "Raw Hemp", percent: 40 },
    ],
    tech_pack: {
      chest: "110 cm",
      sleeve: "23 cm",
      length: "72 cm",
      fiber_density: "240 GSM",
      tensile_strength: "46 N/mm²",
      weight_gsm: "240",
    },
    created_at: "2026-06-12T12:00:00.000Z",
  },
  {
    id: "mens-winter-hemp-sweater",
    name: "Men's Thermal Hemp Waffle Crewneck Sweater",
    price: 138.0,
    gender: "Men",
    category: "Sweaters & Knitwear",
    subcategory: "Sweaters",
    season: "Winter",
    material: "Raw Hemp Jersey",
    sizes: ["S", "M", "L", "XL", "XXL"],
    color_palette: "Deep Indigo",
    eco_rating: 97.8,
    carbon_label: "97.8% Carbon Negative",
    stock: 38,
    is_new: true,
    featured: false,
    activation_temp: "None",
    description:
      "Heavyweight winter thermal waffle-knit pullover sweater made of pure unbleached hemp and bamboo fleece backing. Zero logos, timeless fit.",
    images: [
      "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Raw Hemp", percent: 70 },
      { material: "Bamboo Fleece", percent: 30 },
    ],
    tech_pack: {
      chest: "116 cm",
      sleeve: "66 cm",
      length: "73 cm",
      fiber_density: "410 GSM",
      tensile_strength: "60 N/mm²",
      weight_gsm: "410",
    },
    created_at: "2026-06-11T12:00:00.000Z",
  },
  {
    id: "mens-hemp-tailored-pants",
    name: "Men's Relaxed Hemp & Bamboo Everyday Pants",
    price: 118.0,
    gender: "Men",
    category: "Pants & Shorts",
    subcategory: "Pants",
    season: "Autumn",
    material: "Bamboo-Hemp Blend",
    sizes: ["S", "M", "L", "XL", "XXL"],
    color_palette: "Sage Moss",
    eco_rating: 98.2,
    carbon_label: "98.2% Carbon Negative",
    stock: 44,
    is_new: false,
    featured: false,
    activation_temp: "None",
    description:
      "Versatile straight-leg trousers woven from organic hemp canvas brushed with bamboo viscose. Built for four-season durability and all-day comfort.",
    images: [
      "https://images.unsplash.com/photo-1473966968600-fa801b869a1a?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Raw Hemp", percent: 65 },
      { material: "Bamboo Viscose", percent: 35 },
    ],
    tech_pack: {
      chest: "—",
      sleeve: "—",
      length: "105 cm",
      fiber_density: "320 GSM",
      tensile_strength: "56 N/mm²",
      weight_gsm: "320",
    },
    created_at: "2026-06-10T12:00:00.000Z",
  },
  {
    id: "mens-bamboo-terry-shorts",
    name: "Men's Bamboo Loopback Lounge Shorts",
    price: 72.0,
    gender: "Men",
    category: "Pants & Shorts",
    subcategory: "Shorts",
    season: "Summer",
    material: "Organic Bamboo Silk",
    sizes: ["S", "M", "L", "XL", "XXL"],
    color_palette: "Obsidian Black",
    eco_rating: 98.6,
    carbon_label: "98.6% Carbon Negative",
    stock: 50,
    is_new: true,
    featured: false,
    activation_temp: "None",
    description:
      "7-inch inseam summer shorts in breathable bamboo-hemp french terry with concealed drawstring waist and deep pockets.",
    images: [
      "https://images.unsplash.com/photo-1565084888279-aca607ecce0c?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Bamboo Terry", percent: 80 },
      { material: "Organic Hemp", percent: 20 },
    ],
    tech_pack: {
      chest: "—",
      sleeve: "—",
      length: "46 cm",
      fiber_density: "280 GSM",
      tensile_strength: "42 N/mm²",
      weight_gsm: "280",
    },
    created_at: "2026-06-09T12:00:00.000Z",
  },
  {
    id: "mens-bamboo-silk-boxer-brief-3pack",
    name: "Men's Bamboo Silk Boxer Briefs (3-Pack)",
    price: 54.0,
    gender: "Men",
    category: "Underwear & Lingerie",
    subcategory: "Men's Underwear",
    season: "Spring",
    material: "Organic Bamboo Silk",
    sizes: ["S", "M", "L", "XL", "XXL"],
    color_palette: "Obsidian Black",
    eco_rating: 99.0,
    carbon_label: "99.0% Carbon Negative",
    stock: 85,
    is_new: true,
    featured: false,
    activation_temp: "None",
    description:
      "Ultra-breathable, anti-chafing men's boxer briefs spun from cooling bamboo silk and hemp modal. Tagless, unbranded waistband with ergonomic pouch.",
    images: [
      "https://images.unsplash.com/photo-1586363104862-3a5e2ab60d99?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Organic Bamboo Viscose", percent: 88 },
      { material: "Hemp Modal", percent: 7 },
      { material: "Bio-Elastane", percent: 5 },
    ],
    tech_pack: {
      chest: "—",
      sleeve: "—",
      length: "15 cm inseam",
      fiber_density: "170 GSM",
      tensile_strength: "34 N/mm²",
      weight_gsm: "170",
    },
    created_at: "2026-06-08T12:00:00.000Z",
  },
  {
    id: "mens-hemp-modal-trunks",
    name: "Men's Hemp & Bamboo Everyday Trunks (2-Pack)",
    price: 42.0,
    gender: "Men",
    category: "Underwear & Lingerie",
    subcategory: "Men's Underwear",
    season: "Summer",
    material: "Bamboo-Hemp Blend",
    sizes: ["S", "M", "L", "XL", "XXL"],
    color_palette: "Sage Moss",
    eco_rating: 98.9,
    carbon_label: "98.9% Carbon Negative",
    stock: 60,
    is_new: false,
    featured: false,
    activation_temp: "None",
    description:
      "Low-profile men's trunks with natural antimicrobial hemp-bamboo knit for all-day freshness and temperature regulation.",
    images: [
      "https://images.unsplash.com/photo-1618354691373-d851c5c3a990?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Bamboo Viscose", percent: 72 },
      { material: "Raw Hemp Micro-Modal", percent: 23 },
      { material: "Bio-Elastane", percent: 5 },
    ],
    tech_pack: {
      chest: "—",
      sleeve: "—",
      length: "10 cm inseam",
      fiber_density: "165 GSM",
      tensile_strength: "35 N/mm²",
      weight_gsm: "165",
    },
    created_at: "2026-06-07T12:00:00.000Z",
  },

  // ===================== UNBRANDED ACTIVEWEAR & WORKOUT (MEN & WOMEN) =====================
  {
    id: "womens-sculpt-bamboo-workout-leggings",
    name: "Women's Blank Sculpt Bamboo High-Rise Legging",
    price: 98.0,
    gender: "Women",
    category: "Activewear & Workout",
    subcategory: "Workout & Activewear",
    season: "Autumn",
    material: "Bamboo Compression Knit",
    sizes: ["XS", "S", "M", "L", "XL"],
    color_palette: "Obsidian Black",
    eco_rating: 98.3,
    carbon_label: "98.3% Carbon Negative",
    stock: 55,
    is_new: true,
    featured: true,
    activation_temp: "None",
    description:
      "Pure, unbranded studio-to-street workout legging in four-way stretch bamboo compression interlock. Squat-proof, moisture-wicking, and completely free of external logos.",
    images: [
      "https://images.unsplash.com/photo-1506629082955-511b1aa562c8?auto=format&fit=crop&w=900&q=85",
      "https://images.unsplash.com/photo-1518611012118-696072aa579a?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Bamboo Compression Interlock", percent: 82 },
      { material: "Bio-Based Elastane", percent: 18 },
    ],
    tech_pack: {
      chest: "—",
      sleeve: "—",
      length: "96 cm",
      fiber_density: "260 GSM",
      tensile_strength: "52 N/mm²",
      weight_gsm: "260",
    },
    created_at: "2026-06-06T12:00:00.000Z",
  },
  {
    id: "womens-blank-studio-workout-set",
    name: "Women's Seamless Bamboo Workout Tank & Bra",
    price: 74.0,
    gender: "Women",
    category: "Activewear & Workout",
    subcategory: "Workout & Activewear",
    season: "Summer",
    material: "Bamboo Compression Knit",
    sizes: ["XS", "S", "M", "L", "XL"],
    color_palette: "Terracotta Rose",
    eco_rating: 98.1,
    carbon_label: "98.1% Carbon Negative",
    stock: 46,
    is_new: true,
    featured: false,
    activation_temp: "None",
    description:
      "Minimalist, zero-logo cropped workout tank with integrated medium-impact bamboo support bra. Engineered for yoga, pilates, and high-heat training.",
    images: [
      "https://images.unsplash.com/photo-1518310383802-640c2de311b2?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Bamboo Performance Knit", percent: 85 },
      { material: "Bio-Elastane", percent: 15 },
    ],
    tech_pack: {
      chest: "84 cm",
      sleeve: "—",
      length: "42 cm",
      fiber_density: "240 GSM",
      tensile_strength: "44 N/mm²",
      weight_gsm: "240",
    },
    created_at: "2026-06-05T12:00:00.000Z",
  },
  {
    id: "mens-blank-bamboo-workout-shirt",
    name: "Men's Unbranded Bamboo Performance Training Tee",
    price: 68.0,
    gender: "Men",
    category: "Activewear & Workout",
    subcategory: "Workout & Activewear",
    season: "Spring",
    material: "Bamboo Compression Knit",
    sizes: ["S", "M", "L", "XL", "XXL"],
    color_palette: "Deep Indigo",
    eco_rating: 98.4,
    carbon_label: "98.4% Carbon Negative",
    stock: 58,
    is_new: true,
    featured: false,
    activation_temp: "None",
    description:
      "Athletic-cut workout shirt crafted from micro-perforated bamboo-hemp mesh. Naturally odor-resistant, rapid-drying, and completely blank for a clean personalized silhouette.",
    images: [
      "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Bamboo Micro-Mesh", percent: 75 },
      { material: "Hemp Performance Yarn", percent: 20 },
      { material: "Bio-Elastane", percent: 5 },
    ],
    tech_pack: {
      chest: "106 cm",
      sleeve: "21 cm",
      length: "71 cm",
      fiber_density: "175 GSM",
      tensile_strength: "40 N/mm²",
      weight_gsm: "175",
    },
    created_at: "2026-06-04T12:00:00.000Z",
  },
  {
    id: "mens-blank-workout-running-shorts",
    name: "Men's Unbranded Hemp-Stretch Workout Shorts",
    price: 78.0,
    gender: "Men",
    category: "Activewear & Workout",
    subcategory: "Workout & Activewear",
    season: "Summer",
    material: "Bamboo Compression Knit",
    sizes: ["S", "M", "L", "XL", "XXL"],
    color_palette: "Obsidian Black",
    eco_rating: 98.0,
    carbon_label: "98.0% Carbon Negative",
    stock: 49,
    is_new: true,
    featured: false,
    activation_temp: "None",
    description:
      "6-inch performance training shorts with a built-in bamboo compression liner and four-way hemp-stretch outer shell. Zero logos, pure athletic function.",
    images: [
      "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?auto=format&fit=crop&w=900&q=85",
    ],
    composition: [
      { material: "Hemp 4-Way Stretch", percent: 55 },
      { material: "Bamboo Compression Liner", percent: 35 },
      { material: "Bio-Elastane", percent: 10 },
    ],
    tech_pack: {
      chest: "—",
      sleeve: "—",
      length: "41 cm",
      fiber_density: "195 GSM",
      tensile_strength: "48 N/mm²",
      weight_gsm: "195",
    },
    created_at: "2026-06-03T12:00:00.000Z",
  },
];

export const INITIAL_USERS = [
  {
    user_id: "user_admin_001",
    email: "admin@telluricgaia.com",
    name: "Lab Admin",
    password: "TelluricAdmin#2026",
    role: "admin",
    auth_provider: "password",
    picture: null,
    created_at: "2026-01-01T00:00:00.000Z",
  },
  {
    user_id: "user_operator_001",
    email: "operator@telluricgaia.com",
    name: "Field Operator",
    password: "TelluricUser#2026",
    role: "customer",
    auth_provider: "password",
    picture: null,
    created_at: "2026-01-02T00:00:00.000Z",
  },
];
